/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Sms
 */
export interface Sms {
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  contactKey?: string;
  /**
   *
   * @type {number | null}
   * @memberof Sms
   */
  dateCreated?: number | null;
  /**
   *
   * @type {number}
   * @memberof Sms
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  deliveryStatus?: SmsDeliveryStatusEnum;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  direction: SmsDirectionEnum;
  /**
   *
   * @type {string | null}
   * @memberof Sms
   */
  fromNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  key: string;
  /**
   *
   * @type {boolean | null}
   * @memberof Sms
   */
  mms?: boolean | null;
  /**
   *
   * @type {string | null}
   * @memberof Sms
   */
  senderId?: string | null;
  /**
   *
   * @type {number}
   * @memberof Sms
   */
  smsId?: number;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  targetId?: string;
  /**
   *
   * @type {string}
   * @memberof Sms
   */
  targetKey?: string;
  /**
   *
   * @type {string | null}
   * @memberof Sms
   */
  text?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Sms
   */
  toNumber?: Array<any>;
}

/**
 * @export
 */
export const SmsDeliveryStatusEnum = {
  Accepted: 'accepted',
  InvalidDestination: 'invalid_destination',
  InvalidSource: 'invalid_source',
  NoRoute: 'no_route',
  RejectedSpam: 'rejected_spam',
  Rejected: 'rejected',
  InternalError: 'internal_error',
  NotSupported: 'not_supported',
  Unknown: 'unknown',
} as const;
export type SmsDeliveryStatusEnum =
  (typeof SmsDeliveryStatusEnum)[keyof typeof SmsDeliveryStatusEnum];

/**
 * @export
 */
export const SmsDirectionEnum = {
  Inbound: 'inbound',
  Outbound: 'outbound',
} as const;
export type SmsDirectionEnum =
  (typeof SmsDirectionEnum)[keyof typeof SmsDirectionEnum];

/**
 * Check if a given object implements the Sms interface.
 */
export function instanceOfSms(value: object): value is Sms {
  if (!('direction' in value) || value['direction'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function SmsFromJSON(json: any): Sms {
  return SmsFromJSONTyped(json, false);
}

export function SmsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sms {
  if (json == null) {
    return json;
  }
  return {
    contactId: json['contact_id'] == null ? undefined : json['contact_id'],
    contactKey: json['contact_key'] == null ? undefined : json['contact_key'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    deliveryStatus:
      json['delivery_status'] == null ? undefined : json['delivery_status'],
    direction: json['direction'],
    fromNumber: json['from_number'] == null ? undefined : json['from_number'],
    id: json['id'],
    key: json['key'],
    mms: json['mms'] == null ? undefined : json['mms'],
    senderId: json['sender_id'] == null ? undefined : json['sender_id'],
    smsId: json['sms_id'] == null ? undefined : json['sms_id'],
    targetId: json['target_id'] == null ? undefined : json['target_id'],
    targetKey: json['target_key'] == null ? undefined : json['target_key'],
    text: json['text'] == null ? undefined : json['text'],
    toNumber: json['to_number'] == null ? undefined : json['to_number'],
  };
}

export function SmsToJSON(value?: Sms | null): any {
  if (value == null) {
    return value;
  }
  return {
    contact_id: value['contactId'],
    contact_key: value['contactKey'],
    date_created: value['dateCreated'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    delivery_status: value['deliveryStatus'],
    direction: value['direction'],
    from_number: value['fromNumber'],
    id: value['id'],
    key: value['key'],
    mms: value['mms'],
    sender_id: value['senderId'],
    sms_id: value['smsId'],
    target_id: value['targetId'],
    target_key: value['targetKey'],
    text: value['text'],
    to_number: value['toNumber'],
  };
}
